import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { IsActiveFlag } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiIsActiveBadge',
  props: {
    modelValue: { type: [Object, Boolean] }
  },
  setup(__props: any) {



const shouldRender = computed(() => {
    return (
        typeof __props.modelValue === 'boolean' ||
        (typeof __props.modelValue === 'object' && 'isActive' in __props.modelValue)
    );
});

const isActive = computed(() => {
    if (typeof __props.modelValue === 'boolean') return __props.modelValue;
    if (typeof __props.modelValue === 'object') return __props.modelValue.isActive;
    return false;
});

return (_ctx: any,_cache: any) => {
  return (shouldRender.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([[isActive.value ? 'bg-success-50 text-success-700' : 'bg-danger-100 text-danger-700'], "inline-flex rounded-full px-2 font-semibold"])
      }, _toDisplayString(isActive.value ? _ctx.$t('core.options.Active') : _ctx.$t('core.options.Inactive')), 3))
    : _createCommentVNode("", true)
}
}

})